import { useTranslation } from 'react-i18next'

import { Modal } from '@/components/ui'
import ClientForm from '@/features/clients/ClientForm'
import type { Client } from '@/types/api'

/**
 * Nový klient mimo kalendára.
 *
 * Doteraz klient vznikal len ako vedľajší produkt zakladania rezervácie, čo
 * je v poriadku na svahu, ale nie na recepcii - tam sa človek zapíše skôr,
 * než sa vie, kedy pôjde na lekciu.
 *
 * Po uložení sa otvorí jeho detail: takmer vždy nasleduje „a teraz mu pridám
 * rezerváciu“ alebo aspoň kontrola, či sa všetko zapísalo.
 */
export default function NewClientModal({
  onClose,
  onCreated,
}: {
  onClose: () => void
  onCreated?: (client: Client) => void
}) {
  const { t } = useTranslation()

  return (
    <Modal open onClose={onClose} size="md" title={t('clients.create')}>
      <ClientForm
        onDone={(client) => {
          // `onDone` sa volá aj pri zrušení - vtedy bez klienta.
          if (client && onCreated) onCreated(client)
          onClose()
        }}
      />
    </Modal>
  )
}
